module.exports = __webpack_public_path__ + "img/MorrigansVengeance.75876f11.webp";